<script lang="ts">
    import type {EditorsLocalizationFunction} from '../../../localizations/types';
    import type {SingleAcceptableValueEditorLocalizations} from './types';
    import {isNull} from 'shared/utils/custom-utils';
    import {getContext} from 'svelte';
    import {EDITORS_LOCALIZE} from '../../../context-keys';

    export let optionIdentifier: string | number | null;

    const localize: EditorsLocalizationFunction<SingleAcceptableValueEditorLocalizations> = getContext(EDITORS_LOCALIZE);
</script>

{#if isNull(optionIdentifier)}
    {localize('noneOfTheOptions')}
{:else}
    <slot {optionIdentifier}></slot>
{/if}